var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',[(_vm.isLoggedIn)?_c('v-container',[_c('BookHeader')],1):(this.$route.meta.isPublic)?_c('v-container',[_c('PublicHeader')],1):_vm._e(),(_vm.isLoggedIn)?_c('v-container',[_c('SidebarComponent')],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }